class SalutArticle extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-article-content]');
    this.buildTableOfContents();
  }

  buildTableOfContents() {
    const desktop = this.querySelector('[data-toc]');
    const mobile = this.querySelector('[data-toc-mobile]');
    const targets = [this.querySelector('[data-toc-links]'), this.querySelector('[data-toc-mobile-links]')].filter(
      Boolean
    );

    if (!this.content || targets.length === 0) return;

    const headings = Array.from(this.content.querySelectorAll('h2, h3')).filter(
      (heading) => heading.textContent.trim() !== ''
    );

    if (headings.length === 0) return;

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `${this.slugify(heading.textContent)}-${index + 1}`;

      targets.forEach((target) => {
        const link = document.createElement('a');
        link.className = 'salut-article__toc-link';
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        if (heading.tagName === 'H3') link.classList.add('salut-article__toc-link--nested');
        target.appendChild(link);
      });
    });

    if (desktop) desktop.hidden = false;
    if (mobile) {
      mobile.hidden = false;
      mobile.addEventListener('click', (event) => {
        if (event.target.closest('.salut-article__toc-link')) mobile.open = false;
      });
    }
  }


  slugify(value) {
    return value
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 48);
  }
}

if (!customElements.get('salut-article')) customElements.define('salut-article', SalutArticle);
